/**
 * File view.js.
 *
 * Handles logo list blocks.
 */
(function ($) {
    'use strict';
    $(document).ready(function () {
        checkLastRowItems();

        $(window).on('resize', function(){
            checkLastRowItems();
        });
    });

    function checkLastRowItems() {
        $('.logo-list').each(function(){
            let totalItems = $(this).find('.logo-list__row .logo-list__item').length;
            if ( 0 < totalItems ) {
                let windowWidth = $(window).outerWidth();
                let itemsPerRow = 2;
                
                if ( 991 < windowWidth ) {
                    itemsPerRow = 4;
                } else if( 576 < windowWidth ) {
                    itemsPerRow = 3;
                }
                
                $(this).find('.logo-list__row .logo-list__item').removeClass('last-row-item');
                
                // Calculate the number of rows and items in the last row
                let itemsInLastRow = totalItems % itemsPerRow || itemsPerRow;

                // Calculate the starting index of the last row items
                let startIndex = totalItems - itemsInLastRow + 1;

                // Add a class to the last row items
                for (let i = startIndex; i <= totalItems; i++) {
                    $(this).find('.logo-list__row .logo-list__item:nth-child(' + i + ')').addClass('last-row-item');
                }
            }
        });
    }
})(jQuery);